export default "__VITE_ASSET__CvHOcAvp__"